import React, { useEffect } from "react";
import { Modal } from 'antd'
import store from 'store'
// import useSubmit from "../../hooks/useSubmit";
// import apiUrls from "../../services/apiUrls";
import Button from "../../../styled/Button";
import PageLoader from "../PageLoader";
import PublicLayout from '../../../../layouts/Public'
// import { deleteToken } from "../../utils/cookies";


const Logout = () => {
  // const submit = useSubmit()[1];

  useEffect(() => {
    const logout = async () => {
      try {
        // await submit({
        //  url: apiUrls.logout,
        //  method: "DELETE",
        // });
        store.clearAll();
      } finally {
        // deleteToken();
        window.location.reload();
      }
    };

    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PublicLayout>
      <PageLoader />
    </PublicLayout>
  );
};

export const LogoutModal = ({ isOpen, close, onLogout, themeColor }) => {
  return (
    <>
      <Modal visible={isOpen} onCancel={close} footer={null} centered width={460}>
        <div className='sign-in-modal'>
          <div className='sign-in-header'>
            <p className="sign-in-sub-text"><br /><b>Are your sure you want to logout?</b></p>
          </div>
        </div><br />
        <div className="text-right">
          <Button size="large" type="danger" style={{ fontSize: 18, height: 50, borderRadius: 5, backgroundColor: themeColor, color: '#ffffff' }} htmlType="submit" onClick={onLogout} block>
            Logout
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Logout;
